import { globalEntitlements } from '../utils/globalEntitlements';

export const BENEFICIAL_OWNERSHIP_FILING_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [{ title: 'productPage.bof.buyBox.bulletPoint1' }],
        productName: 'productPage.bof.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.bof.buyBox.veloCta.prompt',
          topic: 'beneficial-ownership-filing',
        },
        interactService: {
          ctaType: 'internalCheckout',
          service: 'beneficial_ownership_filing',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/woman-using-laptop-home-office.png',
      alt: 'productPage.bof.heroPicture.altText',
    },
    headline: 'productPage.bof.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    pill: {},
    subheader: 'productPage.bof.page.subheader',
  },
  highlight: {
    icon: '/s2/material-icons/questionmarkrounded.svg',
    title: 'productPage.bof.topFeature.title',
    subheader: 'productPage.bof.topFeature.subheader',
    image: '/s2/raster/smiling-woman-indoor-plant-shop.png',
    alt: 'productPage.bof.topFeature.altText',
  },
  benefit: {
    title: 'productPage.bof.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/lightbulbrounded.svg',
        title: 'productPage.bof.valueProp.propTitle1',
        description: 'productPage.bof.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/desktopMacRounded.svg',
        title: 'productPage.bof.valueProp.propTitle2',
        description: 'productPage.bof.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/lockRounded.svg',
        title: 'productPage.bof.valueProp.propTitle3',
        description: 'productPage.bof.valueProp.shortCopy3',
      },
    ],
  },
  howItWorks: {
    title: 'productPage.bof.howItWorks.title',
    items: [
      {
        title: 'productPage.bof.howItWorks.step1',
        description: 'productPage.bof.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.bof.howItWorks.step2',
        description: 'productPage.bof.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.bof.howItWorks.step3',
        description: 'productPage.bof.howItWorks.shortDescription3',
      },
    ],
    image: '/s2/raster/warehouse-workers-organizing-boxes.png',
    alt: 'productPage.bof.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.bof.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.bof.frequentlyAskedQuestions.faq1',
        answer: 'productPage.bof.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.bof.frequentlyAskedQuestions.faq2',
        answer: 'productPage.bof.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.bof.frequentlyAskedQuestions.faq3',
        answer: 'productPage.bof.frequentlyAskedQuestions.faqAnswer3',
      },
      {
        question: 'productPage.bof.frequentlyAskedQuestions.faq4',
        answer: 'productPage.bof.frequentlyAskedQuestions.faqAnswer4',
      },
      {
        question: 'productPage.bof.frequentlyAskedQuestions.faq5',
        answer: 'productPage.bof.frequentlyAskedQuestions.faqAnswer5',
      },
    ],
  },
  assistance: {
    title: 'productPage.bof.needAssistance.title',
    getInTouch: 'productPage.bof.needAssistance.getInTouch',
    actions: 'productPage.bof.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.bof.buyBox.buttonLabel',
    ownedCtaText: 'productPage.bof.buyBox.buttonLabel.owned',
    ctaDisabledTooltip: 'productPage.bof.buyBox.buttonDisabled.tooltip',
  })
    .currentProductNotPurchased()
    .build(),
};
